<template>

  <MassiveTable />

</template>

<script>
import MassiveTable from '../components/pratiche/TableMassive.vue'

export default {
  pageName: 'Massive',
  components: {
    MassiveTable

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
